"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ResultsTableModule = _interopRequireDefault(require("../../scss/ResultsTable.module.scss"));
function ResultsTableHeader(_ref) {
  let {
    columns = []
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: [_ResultsTableModule.default['results-table__row'], _ResultsTableModule.default['results-table__header-row'], 'results-table__header-row'].join(' ')
  }, columns.map(column => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: [_ResultsTableModule.default['results-table__header'], "results-table__".concat(column.title.replace(' ', '-').toLowerCase()), 'results-table__header'].join(' '),
      key: "result-header-".concat(column.title)
    }, column.title);
  }));
}
var _default = exports.default = ResultsTableHeader;